import { defineStore } from 'pinia'

export const useStoreInboxUnreadStatus = defineStore('inboxUnreadStatus', {
    state: () => ({ inboxHasUnreadMessages: false }),
    actions: { saveInboxHasUnreadMessages(newStatus) { this.inboxHasUnreadMessages = newStatus; } },
    getters: { getInboxHasUnreadMessages: (state) => () => state.inboxHasUnreadMessages },
    persist: true,
})